import { v4 as uuidv4 } from "uuid";
import axios from "@/utils/axios";

const API_BASE = process.env.NEXT_PUBLIC_API_URL ?? "https://api.basmti.com";

type EventName =
    // Behavioral
    | "session_started" //ask
    | "session_ended" //ask
    | "page_view"
    | "inactive_timeout" //ask
    // Product
    | "view_product"
    | "add_to_cart"
    | "remove_from_cart"
    | "view_cart"
    // Checkout
    | "begin_checkout"
    | "add_shipping_info"
    | "add_payment_info"
    | "apply_coupon"
    | "payment_attempted"
    | "payment_failed"
    | "purchase"
    | "order_failed"
    // Usera
    | "signup_started"
    | "signup_completed"
    | "login"
    | "logout";

interface TrackPayload {
    event_name: EventName;
    current_page?: string;
    previous_pages?: string[];
    metadata?: Record<string, unknown>;
    user_id?: string | null;
}

function getSessionId(): string {
    const key = "bsmt_sid";
    let sid = sessionStorage.getItem(key);
    if (!sid) {
        sid = uuidv4();
        sessionStorage.setItem(key, sid);
    }
    return sid;
}

export async function track(payload: TrackPayload): Promise<void> {
    const body = {
        session_id: getSessionId(),
        occurred_at: new Date().toISOString(),
        previous_pages:
            typeof window !== "undefined"
                ? [document.referrer].filter(Boolean)
                : [],
        current_page:
            typeof window !== "undefined"
                ? window.location.pathname
                : undefined,
        ...payload,
    };

    try {
        await axios.post(
            `${API_BASE}/events`,
            body,
            {
            headers: {
                "Content-Type": "application/json",
            },
            }
        );
    } catch {
        // Silently fail — analytics must never break the UX
    }
}